import React from 'react';
import { Sun, Moon } from 'lucide-react';
import { useTheme } from '../../contexts/ThemeContext';

const ThemeToggle = ({ variant = 'default', showLabel = false, className = '' }) => {
  const { isDarkMode, toggleTheme } = useTheme();

  if (variant === 'switch') {
    return (
      <button
        onClick={toggleTheme}
        className={`apple-theme-switch ${isDarkMode ? 'dark' : 'light'} ${className}`}
        aria-label={isDarkMode ? 'Switch to light mode' : 'Switch to dark mode'}
        data-testid="theme-toggle-switch"
      >
        <span className="apple-theme-switch-track">
          <span className="apple-theme-switch-thumb">
            {isDarkMode ? <Moon size={12} /> : <Sun size={12} />}
          </span>
        </span>
        {showLabel && (
          <span className="apple-theme-switch-label">
            {isDarkMode ? 'Dark' : 'Light'}
          </span>
        )}
      </button>
    );
  }

  // Default icon button
  return (
    <button
      onClick={toggleTheme}
      className={`apple-btn apple-btn-ghost apple-btn-icon apple-theme-toggle ${className}`}
      aria-label={isDarkMode ? 'Switch to light mode' : 'Switch to dark mode'}
      data-testid="theme-toggle-btn"
      title={isDarkMode ? 'Switch to light mode' : 'Switch to dark mode'}
    >
      {isDarkMode ? <Sun size={20} /> : <Moon size={20} />}
    </button>
  );
};

export default ThemeToggle;
